// src/components/Developer/Developer.js
import React from 'react';
import './Developer.css';
import vijayImage from './vijay.png';
import { FaGithub, FaInstagram, FaLinkedin, FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";

const Developer = () => {
  return (
    <div className="dev-resume-container">
      <div className="dev-grid">
        <div className="dev-left">
          <h1 className="dev-name">CHINNI VIJAY KUMAR</h1>
          <p className="dev-title">Student Developer | Cyber Security • AI • Web Developer</p>

          <div className="dev-info">
            <p><strong><FaLocationDot/> Address:</strong> 31-25-47, Sri Krishna Nagar, Kurmannapalem, Visakhapatnam</p>
            <p><strong><FaPhoneAlt/> Phone:</strong> +91-9966798059</p>
            <p><strong><MdEmail/> Email:</strong> vijaykumarchinni24122004@gmail.com</p>
            <p><strong><FaInstagram/> Instagram:</strong> <a href="https://www.instagram.com/ch.vijay2412?igsh=YnpnaWllNWRiMzlr" target="_blank" rel="noreferrer">ch.vijay2412</a></p>
            <p><strong><FaLinkedin/> LinkedIn:</strong> <a href="http://www.linkedin.com/in/vijay-kumar-chinni-6aa9352b4" target="_blank" rel="noreferrer">CHINNI VIJAY KUMAR</a></p>
            <p><strong><FaGithub/> GitHub:</strong> <a href="https://github.com/Lucifer-FallenAngel" target="_blank" rel="noreferrer">Vijay-Kumar</a></p>
          </div>

          <div className="dev-bio">
            <p>
              A passionate web developer and cybersecurity enthusiast. I love combining UI/UX with functionality — ensuring performance, security, and clean design in every project.
              <br /><br />
              Experienced with ReactJS, Node.js, Express, Sequelize, MySQL, and REST APIs. I actively explore modern tools like React Native and AI integrations, and I enjoy automating administrative workflows.
            </p>
          </div>
        </div>

        <div className="dev-right">
          <img src={vijayImage} alt="CHINNI VIJAY KUMAR" className="dev-photo" />
        </div>
      </div>

      <div className="dev-footer">
        <h2>About This Website</h2>
        <p>
          The <strong>DIET ACM Chapter</strong> website was designed using <strong>Figma</strong> and built with <strong>ReactJS</strong>, with a powerful admin panel for real-time content management.
          <br /><br />
          The backend is developed using <strong>Node.js</strong> and <strong>Express.js</strong>, with structured data managed via <strong>Sequelize ORM</strong> and stored in <strong>MySQL</strong>.
          <br /><br />
          Key features include:
          <ul>
            <li>🧩 Modular admin pages for blogs, events, gallery, calendar, and team</li>
            <li>📅 Calendar integration using <strong>react-calendar</strong></li>
            <li>📌 First-time popup announcements with upload control</li>
            <li>📞 Live updating contact number and membership form</li>
          </ul>
          <br />
          A special thanks to <strong>ChatGPT</strong> for assisting with logic structuring, bug fixing, Sequelize modeling, and UI decisions throughout development.
        </p>
      </div>
    </div>
  );
};

export default Developer;
